import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "23",
  fill: "none",
  viewBox: "0 0 22 23"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#032E32",
      d: "M15.169 12.083c.687 0 1.292-.376 1.604-.944l3.281-5.949a.914.914 0 0 0-.797-1.357H5.69L4.83 2h-3v1.833h1.833l3.3 6.958-1.237 2.236c-.67 1.229.21 2.723 1.604 2.723h11v-1.833h-11l1.008-1.834zM6.56 5.667H17.7l-2.53 4.583H8.734zm.77 11A1.83 1.83 0 0 0 5.507 18.5a1.83 1.83 0 0 0 1.824 1.833A1.84 1.84 0 0 0 9.164 18.5a1.84 1.84 0 0 0-1.833-1.833m9.167 0a1.83 1.83 0 0 0-1.824 1.833 1.83 1.83 0 0 0 1.824 1.833A1.84 1.84 0 0 0 18.33 18.5a1.84 1.84 0 0 0-1.833-1.833"
    }, null, -1)
  ])))
}
export default { render: render }